import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  height: ", "px;\n  width: ", "px;\n  margin: auto;\n\n  path {\n    &[stroke] {\n      stroke: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect, useRef } from 'react';
import Lottie from 'lottie-react';
import styled from '../utils/styling/styled-components';
import { theme } from '../theme';
import { SPINNER } from '../utils/testing/TestIDs';
import animationData from './GreyFeedLoader-01.json';
var SPINNER_SIZE = 34;
var SpinnerContainer = styled.div(_templateObject(), function (props) {
  var _props$height;

  return (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : SPINNER_SIZE;
}, function (props) {
  var _props$width;

  return (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : SPINNER_SIZE;
}, function (props) {
  return props.color ? props.color : theme.colors.white;
});

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      color = _ref.color,
      height = _ref.height,
      width = _ref.width;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      complete = _useState2[0],
      setComplete = _useState2[1];

  var initialRef = useRef(null);
  var loopingRef = useRef(null);

  var handleCompleteInitialAnimation = function handleCompleteInitialAnimation() {
    setComplete(true);
  };

  var initialStyle = {
    display: 'flex',
    position: 'absolute',
    zIndex: 15,
    // banner image zIndex is set to 5
    width: width !== null && width !== void 0 ? width : SPINNER_SIZE,
    // add width/height for Safari
    height: height !== null && height !== void 0 ? height : SPINNER_SIZE // add width/height for Safari

  };
  var loopingStyle = {
    display: 'none',
    position: 'absolute',
    zIndex: 10,
    // banner image zIndex is set to 5
    width: width !== null && width !== void 0 ? width : SPINNER_SIZE,
    // add width/height for Safari
    height: height !== null && height !== void 0 ? height : SPINNER_SIZE // add width/height for Safari

  };
  var lottieInitialProps = {
    initialSegment: [0, 111],
    animationData: animationData,
    autoplay: true,
    onComplete: handleCompleteInitialAnimation,
    style: initialStyle
  };
  var lottieLoopProps = {
    initialSegment: [111, 199],
    animationData: animationData,
    loop: true,
    style: loopingStyle
  };
  useEffect(function () {
    var _initialRef$current, _initialRef$current$a, _initialRef$current$a2, _loopingRef$current$a, _loopingRef$current$a2;

    var initialStyle = initialRef === null || initialRef === void 0 ? void 0 : (_initialRef$current = initialRef.current) === null || _initialRef$current === void 0 ? void 0 : (_initialRef$current$a = _initialRef$current.animationItem) === null || _initialRef$current$a === void 0 ? void 0 : (_initialRef$current$a2 = _initialRef$current$a.wrapper) === null || _initialRef$current$a2 === void 0 ? void 0 : _initialRef$current$a2.style;
    var loopingStyle = loopingRef === null || loopingRef === void 0 ? void 0 : (_loopingRef$current$a = loopingRef.current.animationItem) === null || _loopingRef$current$a === void 0 ? void 0 : (_loopingRef$current$a2 = _loopingRef$current$a.wrapper) === null || _loopingRef$current$a2 === void 0 ? void 0 : _loopingRef$current$a2.style;

    if (complete) {
      initialStyle.display = 'none';
      loopingStyle.display = 'flex';
      loopingRef.current.play();
    } else {
      loopingRef.current.pause();
    }
  }, [complete]);
  return /*#__PURE__*/React.createElement(SpinnerContainer, {
    className: className,
    height: height,
    width: width,
    "data-testid": SPINNER,
    color: color
  }, /*#__PURE__*/React.createElement(Lottie, _extends({
    lottieRef: initialRef
  }, lottieInitialProps)), /*#__PURE__*/React.createElement(Lottie, _extends({
    lottieRef: loopingRef
  }, lottieLoopProps)));
};

export { Spinner };